__turbopack_context__.v({
  "DropdownItems": "DropdownItems-module__cGFJhG__DropdownItems",
  "DropdownItemsRight": "DropdownItems-module__cGFJhG__DropdownItemsRight",
});
